module.exports = __webpack_public_path__ + "img/bes-bireysel-emeklilik-sistemi.f0cc360f.svg";